import { useState } from 'react';

import { Badge, ErrorFillIcon, LinkOpenIcon, Modal, Text, TextButton } from '@thefarmersfront/kitchen';

import { COLLECTING_SHIPPING_LABEL_STATUS_BADGE_COLOR, DELIVERY_AGENCY_TRACKING_LINKS } from '~/constants';

import type { CollectingResultReportDetail } from '~/types/delivery-agency.types';

import styles from './CollectingResultReportDetailModal.module.scss';

const CollectingResultReportDetailModal = ({
  open,
  data,
  onClose,
}: {
  open: boolean;
  data: CollectingResultReportDetail;
  onClose: () => void;
}) => {
  const [isImageError, setIsImageError] = useState(false);

  const trackingUrl =
    data.courierCode.code in DELIVERY_AGENCY_TRACKING_LINKS && data.shippingLabelNumber
      ? DELIVERY_AGENCY_TRACKING_LINKS[data.courierCode.code as keyof typeof DELIVERY_AGENCY_TRACKING_LINKS] +
        data.shippingLabelNumber
      : undefined;

  // 화면설계는 사진 미등록·로드 실패를 구분하지 않고 하나의 empty 상태로 본다
  const showImage = !!data.collectingCompletedImageUrl && !isImageError;

  return (
    <Modal title="회수 결과 상세" size="small" open={open} onConfirm={onClose}>
      <div className={styles['container']}>
        {showImage ? (
          <img
            className={styles['collecting-completed-image']}
            src={data.collectingCompletedImageUrl ?? ''}
            alt="회수완료 사진"
            onError={() => setIsImageError(true)}
          />
        ) : (
          <div className={styles['collecting-completed-image-placeholder']}>
            <ErrorFillIcon size={64} color="#bcc4cc" />
            <div className={styles['placeholder-text']}>
              <Text size="xxlarge" weight="semi-bold">
                배송 완료 사진을 불러올 수 없어요
              </Text>
              <Text size="xlarge" color="tertiary">
                {`${data.courierCode.description || '배송사'} 담당자에게 문의해주세요.`}
              </Text>
            </div>
          </div>
        )}
        <div className={styles['info-row']}>
          <div className={styles['shipping-label']}>
            <Text size="large" weight="semi-bold">
              {data.shippingLabelNumber || '-'}
            </Text>
            <Badge
              size="medium"
              variant="light"
              status
              color={COLLECTING_SHIPPING_LABEL_STATUS_BADGE_COLOR[data.collectingShippingLabelStatus.code]}
            >
              {data.collectingShippingLabelStatus.description}
            </Badge>
          </div>
          {trackingUrl && (
            <TextButton
              size="tiny"
              weight="semi-bold"
              variant="normal"
              target="_blank"
              href={trackingUrl}
              rightIcon={<LinkOpenIcon size={16} color="#672091" />}
            >
              회수 조회
            </TextButton>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default CollectingResultReportDetailModal;
